module.exports = __webpack_public_path__ + "static/img/noData.b86516c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/serviceCenter/noData.png
// module id = OlZ4
// module chunks = 44